import './InfoIcon.scss';

export function InfoIcon() {
  return <div className={`info-icon-container`}>i</div>;
}
